import { render, staticRenderFns } from "./AdminUserPassword.form.vue?vue&type=template&id=69115ab8&"
import script from "./AdminUserPassword.form.vue?vue&type=script&lang=js&"
export * from "./AdminUserPassword.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports